import {Component, Input, OnInit, ViewContainerRef} from '@angular/core';
import {MenuItem} from '../customer-menu-item.model';
import {UrlStore} from "@shared/url-store";
import {HttpClient} from "@angular/common/http";
import {NotificationPopupService} from "@shared/notification-popup/services/notification-popup.service";

@Component({
    selector: 'app-customer-menu-item',
    templateUrl: './customer-menu-item.component.html',
    styleUrls: ['./customer-menu-item.component.scss']
})

export class CustomerMenuItemComponent implements OnInit {
    @Input() menuItem: MenuItem;

    constructor(private http: HttpClient,
                private viewContainerRef: ViewContainerRef,
                private notificationSvc: NotificationPopupService) {
    }

    ngOnInit(): void {
    }

    // Switching gives the user full read AND WRITE access to the target TOC -
    // they can save rules and apply overrides there. Read-only cross-Buyer
    // access is not implemented; see docs/toc-switching.md in rail-sora-api.
    public swapTenant(customerId: any) {
        const body = {params: {customer_id: String(customerId)}};
        return this.http.post<any>(UrlStore.api.swapTenant.swapTenantURL, body).toPromise().then(config => {
            // swap_tenant returns the same payload as /config, which is otherwise
            // only fetched during login. Both entries have to be replaced or the
            // reloaded app keeps rendering the previous tenant's configuration.
            localStorage.setItem('userConfig', JSON.stringify(config));
            localStorage.setItem('appConfig', JSON.stringify(config.appConfig));
            this.reload();
        }).catch(error => {
            console.error(error);
            this.notificationSvc.displayNotification(this.viewContainerRef, {
                notificationType: 'error',
                message: error && error.status === 403
                    ? 'You are not authorised to switch to this client system.'
                    : 'Could not switch client system. Please try again.'
            });
        });
    }

    // Seam so the swap can be tested without reloading the test runner.
    protected reload(): void {
        window.location.reload();
    }

}
